/**
 * iva.js — Utilidades de IVA (Costa Rica) para formularios de CxC y CxP.
 *
 * Regla de negocio: el usuario digita la BASE (sin IVA); el sistema agrega el
 * IVA encima → total = base + IVA. El backend recibe `monto` = base y lo
 * promueve al total; aquí calculamos el desglose solo para mostrarlo en la UI.
 */

// Tarifas vigentes en Hacienda CR. 13% es la general (default).
export const TARIFAS_IVA = [
  { valor: 13, label: "13% - General" },
  { valor: 4,  label: "4% - Reducida" },
  { valor: 2,  label: "2% - Reducida" },
  { valor: 1,  label: "1% - Canasta básica" },
  { valor: 0,  label: "0% - Exento" },
];

// Modo de cálculo respecto al monto digitado.
export const IVA_MODOS = [
  { valor: "SUMAR",    label: "Sumar IVA",    hint: "El monto es la base; se suma el IVA" },
  { valor: "INCLUIDO", label: "IVA incluido", hint: "El monto ya incluye el IVA" },
];

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

/**
 * Calcula el desglose según el modo.
 *   modo='SUMAR'    → montoDigitado es la base; total = base + IVA.
 *   modo='INCLUIDO' → montoDigitado es el total; base = total / (1 + tasa).
 * @returns {{ base: number, iva: number, total: number }}
 */
export function calcularIva(montoDigitado, tasa, aplica = true, modo = "SUMAR") {
  const m = Number(montoDigitado) || 0;
  const t = Number(tasa) || 0;
  if (!aplica || t <= 0) return { base: m, iva: 0, total: m };

  if (modo === "INCLUIDO") {
    const total = round2(m);
    const base = round2(total / (1 + t / 100));
    return { base, iva: round2(total - base), total };
  }
  // SUMAR
  const iva = round2((m * t) / 100);
  return { base: round2(m), iva, total: round2(m + iva) };
}
